// extracted by mini-css-extract-plugin
export default {"detailPrdImg":"MobileProductDetailPage_detailPrdImg__IcveX"};